// components/tenants/tenant-list-view.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export const TenantListView = ({ tenant }) => {
    return (
        <div className="card mb-2">
            <div className="card-body p-3">
                <div className="row align-items-center">
                    <div className="col-md-4">
                        <h5 className="mb-0">
                            <Link to={`/tenant/detail/${tenant.id}`}>
                                {tenant.displayName}
                            </Link>
                        </h5>
                    </div>
                    <div className="col-md-3">
                        {tenant.emailAddress}
                    </div>
                    <div className="col-md-3">
                        {tenant.phoneNumber}
                    </div>
                    <div className="col-md-2 text-end">
                        {tenant.balance !== 0 && (
                            <span className={`fs-18px badge ${tenant.balance < 0 ? 'bg-danger' : 'bg-success'}`}>
                                £{Math.abs(tenant.balance).toFixed(2)}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
